import Vue from 'vue'
import VModal from 'vue-js-modal'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AUTH_HEADER } from "./helpers/auth-header";
import {
  ValidationObserver,
  ValidationProvider,
  extend,
} from "vee-validate";

import * as rules from "vee-validate/dist/rules";
import vuetify from './plugins/vuetify';
import VueSweetalert2 from 'vue-sweetalert2';
 
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
import { localize } from 'vee-validate';
import vi from 'vee-validate/dist/locale/vi.json';
import i18n from "./helpers/i18n"


Vue.config.productionTip = false

Vue.use(VModal)
Vue.use( AUTH_HEADER )
Vue.use(VueSweetalert2);


Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

localize('vi', vi);

extend('required', {
  message: (fieldName) => {
    return `${fieldName} không được để trống!`;
  }
});

extend('email', {
  message: (fieldName) => {
    return `${fieldName} không đúng định dạng`;
  }
});
extend('length', {
  message: (fieldName) => {
    return `${fieldName} độ dài chưa đúng`;
  }
});
extend('between', {
  message: (fieldName) => {
    return `${fieldName} không đúng điểm số`;
  }
});
extend("image", {
	message: (fieldName) => {
		return `${fieldName} phải là một ảnh`;
	},
});
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);


new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
